// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const pallet = defineModel({
  id: "pallet",
  batchId: "future",
  name: "Pallet",
  tags: ["scenery","pallet","low-poly","age-of-mcp","future"],
  summary: "A loaded pallet — stacks goods for easy lifting and storage.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.3,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.08, 0.06, 0.5), color: "#6e4f2e", position: [-0.2, 0.03, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 0.06, 0.5), color: "#6e4f2e", position: [0, 0.03, 0] },
      { geometry: new THREE.BoxGeometry(0.08, 0.06, 0.5), color: "#6e4f2e", position: [0.2, 0.03, 0] },
      { geometry: new THREE.BoxGeometry(0.5, 0.04, 0.1), color: "#8a6840", position: [0, 0.08, -0.2] },
      { geometry: new THREE.BoxGeometry(0.5, 0.04, 0.1), color: "#8a6840", position: [0, 0.08, -0.07] },
      { geometry: new THREE.BoxGeometry(0.5, 0.04, 0.1), color: "#8a6840", position: [0, 0.08, 0.07] },
      { geometry: new THREE.BoxGeometry(0.5, 0.04, 0.1), color: "#8a6840", position: [0, 0.08, 0.2] },
      { geometry: new THREE.BoxGeometry(0.24, 0.24, 0.24), color: "#a9763f", position: [-0.1, 0.22, 0] },
      { geometry: new THREE.BoxGeometry(0.2, 0.2, 0.2), color: "#8f6234", position: [0.13, 0.2, -0.02] },
      { geometry: new THREE.BoxGeometry(0.18, 0.18, 0.18), color: "#a9763f", position: [-0.06, 0.41, 0] },
    ],
  animations: [],
});
